import { parseDevice } from './devices'
var username

export function parseUser (userData) {
  username = userData.username
  return {
    id: userData._id || userData.id,
    username: userData.username,
    email: userData.email,
    authDevices: userData.auth_devices.map(parseDevice),
    authFeatures: userData.auth_features,
    role: userData.role
  }
}
export {
  username
}
export function unparseUser (userObj) {
  const {
    username,
    email,
    password,
    // role,
    authDevices,
    authFeatures
  } = userObj
  return {
    username,
    email,
    role: 'user',
    auth_features: authFeatures,
    auth_devices: authDevices,
    ...password && { password }
  }
}



// WEBPACK FOOTER //
// ./src/store/users.js